import { render } from "./Asset_Fees.vue?vue&type=template&id=8267470a"
import script from "./Asset_Fees.vue?vue&type=script&lang=js"
export * from "./Asset_Fees.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__